export default {
    icon: 'el-icon-position',
    title: '导航菜单',
    name: 'menus',
    timestamp: '1665385357481003',
    setUp: {
        tabVal: 0
    },
    tabConfig: {
        title: '展示样式',
        tabVal: 1,
        type: 1,
        tabList: [
            {
                name: '单行展示',
                icon: 'el-icon-more-outline'
            },
            {
                name: '多行展示',
                icon: 'el-icon-menu'
            }
        ]
    },
    rowsNum: {
        title: '显示行数',
        name: 'rowsNum',
        type: 0,
        list: [
            {
                val: '2行',
                icon: 'el-icon-menu'
            },
            {
                val: '3行',
                icon: 'el-icon-s-grid'
            },
            {
                val: '4行',
                icon: 'fa fa-align-justify'
            }
        ]
    },
    menuStyle: {
        title: '图标样式',
        name: 'menuStyle',
        type: 1,
        list: [
            {
                val: '方形',
                icon: 'el-icon-copy-document'
            },
            {
                val: '圆形',
                icon: 'el-icon-s-help'
            }
        ]
    },
    number: {
        title: '显示个数',
        name: 'number',
        type: 2,
        list: [
            {
                val: '3个',
                icon: 'fa fa-battery-2'
            },
            {
                val: '4个',
                icon: 'fa fa-battery-3'
            },
            {
                val: '5个',
                icon: 'fa fa-battery'
            }
        ]
    },
    pointerStyle: {
        title: '指示器样式',
        name: 'pointerStyle',
        type: 2,
        list: [
            {
                val: '长条',
                icon: 'iconSquarepoint'
            },
            {
                val: '圆形',
                icon: 'iconDot'
            },
            {
                val: '无指示器',
                icon: 'iconjinyong'
            }
        ]
    },
    bgStyle: {
        title: '背景样式',
        name: 'bgStyle',
        type: 1,
        list: [
            {
                val: '直角',
                icon: 'el-icon-edit-outline'
            },
            {
                val: '圆角',
                icon: 'el-icon-c-scale-to-original'
            }
        ]
    },
    prConfig: {
        title: '背景边距',
        val: 10,
        min: 0
    },
    menuConfig: {
        title: '最多可添加1张图片，建议宽度90 * 90px',
        maxList: 100,
        list: [
            {
                img:  "SERVER_API" + '/images/decoration/menu_1.png',
                info: [
                    {
                        title: '标题',
                        value: '链接标题',
                        tips: '选填，不超过4个字',
                        max: 4
                    },
                    {
                        title: '链接',
                        value: '/pages',
                        tips: '请输入链接',
                        max: 100
                    }
                ]
            },
            {
                img: "SERVER_API" + '/images/decoration/menu_2.png',
                info: [
                    {
                        title: '标题',
                        value: '领优惠券',
                        tips: '选填，不超过4个字',
                        max: 4
                    },
                    {
                        title: '链接',
                        value: '/pages/users/user_get_coupon/index',
                        tips: '请输入链接',
                        max: 100
                    }
                ]
            },
            {
                img: "SERVER_API" + '/images/decoration/menu_3.png',
                info: [
                    {
                        title: '标题',
                        value: '精品推荐',
                        tips: '选填，不超过4个字',
                        max: 4
                    },
                    {
                        title: '链接',
                        value: '/pages/columnGoods/HotNewGoods/index?type=1&name=精品推荐',
                        tips: '请输入链接',
                        max: 100
                    }
                ]
            },
            {
                img: "SERVER_API" + '/images/decoration/menu_4.png',
                info: [
                    {
                        title: '标题',
                        value: '新闻资讯',
                        tips: '选填，不超过4个字',
                        max: 4
                    },
                    {
                        title: '链接',
                        value: '/pages/extension/news_list/index',
                        tips: '请输入链接',
                        max: 100
                    }
                ]
            },
            {
                img: "SERVER_API" + '/images/decoration/menu_5.png',
                info: [
                    {
                        title: '标题',
                        value: '助力砍价',
                        tips: '选填，不超过4个字',
                        max: 4
                    },
                    {
                        title: '链接',
                        value: '/pages/activity/goods_bargain/index',
                        tips: '请输入链接',
                        max: 100
                    }
                ]
            },
            {
                img: "SERVER_API" + '/images/decoration/menu_6.png',
                info: [
                    {
                        title: '标题',
                        value: '限时秒杀',
                        tips: '选填，不超过4个字',
                        max: 4
                    },
                    {
                        title: '链接',
                        value: '/pages/activity/goods_seckill/index',
                        tips: '请输入链接',
                        max: 100
                    }
                ]
            },
            {
                img: "SERVER_API" + '/images/decoration/menu_7.png',
                info: [
                    {
                        title: '标题',
                        value: '积分商城',
                        tips: '选填，不超过4个字',
                        max: 4
                    },
                    {
                        title: '链接',
                        value: '/pages/points_mall/index',
                        tips: '请输入链接',
                        max: 100
                    }
                ]
            },
            {
                img: "SERVER_API" + '/images/decoration/menu_8.png',
                info: [
                    {
                        title: '标题',
                        value: '团长返佣',
                        tips: '选填，不超过4个字',
                        max: 4
                    },
                    {
                        title: '链接',
                        value: '/pages/activity/goods_combination/index',
                        tips: '请输入链接',
                        max: 100
                    }
                ]
            },
            {
                img: "SERVER_API" + '/images/decoration/menu_9.png',
                info: [
                    {
                        title: '标题',
                        value: '用户足迹',
                        tips: '选填，不超过4个字',
                        max: 4
                    },
                    {
                        title: '链接',
                        value: '/pages/users/visit_list/index',
                        tips: '请输入链接',
                        max: 100
                    }
                ]
            },
            {
                img: "SERVER_API" + '/images/decoration/menu_10.png',
                info: [
                    {
                        title: '标题',
                        value: '幸运转盘',
                        tips: '选填，不超过4个字',
                        max: 4
                    },
                    {
                        title: '链接',
                        value: '/pages/goods/lottery/grids/index?type=1',
                        tips: '请输入链接',
                        max: 100
                    }
                ]
            }
        ]
    },
    pointerColor: {
        title: '指示器颜色',
        name: 'pointerColor',
        default: [
            {
                item: '#f44'
            }
        ],
        color: [
            {
                item: '#f44'
            }
        ]
    },
    bgColor: {
        title: '背景颜色',
        name: 'bgColor',
        default: [
            {
                item: '#fff'
            }
        ],
        color: [
            {
                item: '#fff'
            }
        ]
    },
    titleColor: {
        title: '文字颜色',
        name: 'themeColor',
        default: [
            {
                item: '#333333'
            }
        ],
        color: [
            {
                item: 'rgba(51,51,51,1)'
            }
        ]
    },
    mbConfig: {
        title: '页面间距',
        val: 12,
        min: 0
    },
    id: 'id1665385357481003'
};